import { colors } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon';

interface ShareItemProps {
  actionText: string;
  iconImage: string;
  linkUrl: string;
  onClick: () => void;
  iconClass: string;
  iconCss: { className: string; styles: string };
}

const ShareItem = ({
  actionText,
  iconImage,
  linkUrl,
  onClick,
  iconClass,
  iconCss,
}: ShareItemProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <a
      href={linkUrl}
      target="_blank"
      aria-label={t('accessibility.newWindow')}
      className="icon-row"
      data-testid={actionText}
      onClick={onClick}
    >
      <div className="icon-container">
        <Icon className={`${iconClass} ${iconCss.className}`} image={iconImage} />
      </div>
      <div className="share-action">{actionText}</div>
      <style jsx>{`
        .icon-row {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          width: 232px;
          height: 44px;
          padding: 6px 16px;
          text-decoration: none;
        }

        .icon-row:hover {
          background-color: ${colors.G1};
        }

        .icon-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 32px;
          height: 32px;
          margin-right: 14px;
        }

        .share-action {
          font-size: 16px;
          font-weight: 600;
          color: ${colors.BLACK};
        }
      `}</style>
      {iconCss.styles}
    </a>
  );
};

export default ShareItem;
